import glamorous from 'glamorous';
import {PHONE} from '../../../shared/style/breakpoints';

const Banner = glamorous.div(
  {
    width: '100%',
    height: 215,
    [PHONE]: {
      height: 150
    },
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  ({url}) => ({
    backgroundImage: `url(${url})`
  })
);

export default Banner;
